import React , {useEffect} from "react";
import axios from "axios";
function Offilinestore() {
   useEffect(() => {
      const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
      axios.post(`${backendUrl}/api/analytics/visit`, { page: "Offline Store" })
        .then(res => console.log(" visit recorded:", res.data))
        .catch(err => console.error("Analytics error:", err));
    }, []);
  
  return (
//     <div className="bg-white text-gray-800">
//       {/* Header */}
//       <header className="bg-black text-white py-6 px-4 flex flex-col items-center md:flex-row md:justify-between">
//         <div className="text-center md:text-left">
//           <h1 className="text-2xl font-bold text-orange-500">MAMMOTH STREETWEARS</h1>
//           <p className="text-sm">GST NO : 27AAMP25406D1ZG</p>
//           <p className="text-sm">SHOP NO.: 586, SAGAR ARCADE</p>
//         </div>
//         <div className="text-center mt-3 md:mt-0">
//           <p className="text-lg">📞 +91 95977 08998 | +91 72767 65658</p>
//           <p className="text-sm">🌐 www.mammothstreetwears.com</p>
//         </div>
//       </header>

//       {/* Welcome Section */}
//       <section className="px-6 py-12 text-center">
//         <h2 className="text-3xl font-bold mb-4">Welcome to Mammoth Streetwear</h2>
//         <p className="text-lg max-w-3xl mx-auto text-gray-600">
//           Discover the perfect blend of style, comfort, and quality at Mammoth Streetwear.
//           Located at Sagar Arcade, Shop No.586, Gultekdi Chowk, F.C. Road, Pune – 411004,
//           we are your go-to destination for premium clothing that fits every occasion.
//         </p>
//       </section>

//       {/* What We Offer */}
//       <section className="px-6 py-12 bg-gray-100">
//         <h3 className="text-2xl font-bold text-center mb-6">What We Offer</h3>
//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
//           <div className="p-4 border rounded-lg shadow">
//             <h4 className="font-semibold">👕 Men's Apparel</h4>
//             <p>From sharp suits to casual wear, elevate your wardrobe with our versatile collection.</p>
//           </div>
//           <div className="p-4 border rounded-lg shadow">
//             <h4 className="font-semibold">👗 Women's Fashion</h4>
//             <p>Elegant dresses, trendy tops, and everything in between—crafted to make you shine.</p>
//           </div>
//           <div className="p-4 border rounded-lg shadow">
//             <h4 className="font-semibold">🎒 Accessories</h4>
//             <p>Complete your look with our range of bags, belts, hats, and more.</p>
//           </div>
//           <div className="p-4 border rounded-lg shadow">
//             <h4 className="font-semibold">🔥 Seasonal Specials</h4>
//             <p>Explore exclusive collections tailored to every season and occasion.</p>
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="px-6 py-12 text-center">
//         <h3 className="text-2xl font-bold mb-6">Why Choose Us?</h3>
//         <ul className="space-y-4 max-w-3xl mx-auto text-gray-700">
//           <li>✅ <b>Trendy Collection:</b> Stay ahead of fashion with our handpicked latest pieces.</li>
//           <li>✅ <b>Quality You Can Trust:</b> We source only the finest fabrics for durability and comfort.</li>
//           <li>✅ <b>Personalized Service:</b> Friendly team to help you find the perfect fit.</li>
//           <li>✅ <b>Exclusive Offers:</b> Enjoy promotions and loyalty rewards.</li>
//         </ul>
//       </section>

//       {/* Store Gallery */}
//       <section className="px-6 py-12 bg-gray-100">
//         <h3 className="text-2xl font-bold text-center mb-6">Our Store</h3>
//         <div className="grid md:grid-cols-3 gap-6">
//           <img
//             src="https://via.placeholder.com/400x250"
//             alt="Store Pic 1"
//             className="rounded-lg shadow"
//           />
//           <img
//             src="https://via.placeholder.com/400x250"
//             alt="Store Pic 2"
//             className="rounded-lg shadow"
//           />
//           <img
//             src="https://via.placeholder.com/400x250"
//             alt="Store Pic 3"
//             className="rounded-lg shadow"
//           />
//         </div>
//       </section>

//       {/* Visit Us */}
//       <section className="px-6 py-12 text-center">
//         <h3 className="text-2xl font-bold mb-4">Visit Us Today!</h3>
//         <p className="max-w-2xl mx-auto text-gray-600 mb-4">
//           Step into Mammoth Streetwear and experience fashion like never before. 
//           We're open from 11 AM to 10 PM. Drop by anytime to refresh your wardrobe or get inspired!
//         </p>
//         <p className="font-semibold">📍 Address:</p>
//         <p>Sagar Arcade, Shop No.586, Gudluck Chowk, F.C. Road, Pune - 411004</p>
//         <p>📧 mammothswtr@gmail.com</p>
//         <p>🌐 www.mammothstreetwears.com</p>
//       </section>

//       {/* Footer */}
//       <footer className="bg-black text-white text-center py-4">
//         <p>&copy; {new Date().getFullYear()} Mammoth Streetwears. All Rights Reserved.</p>
//       </footer>
//     </div>
//   );
          //  text-[#FF4902] 
    <div className="bg-white text-gray-800">
      {/* Banner Section */}
      <section
        className="relative w-full bg-cover bg-center"
        style={{
          backgroundImage: "url('https://res.cloudinary.com/dypkxqirq/image/upload/v1755688963/Black_and_Gray_Minimalist_LinkedIn_Banner_oqbiuc.webp')",
        }}
      >
        <div className="bg-black/60 w-full h-full flex items-center justify-center">
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#FF4902] text-center uppercase tracking-wide py-16">
            From Online to On-Ground – We’re Here!
          </h1>
        </div>
      </section>

      {/* Location Heading */}
      <section className="text-center py-10">
        <h2 className="text-2xl md:text-3xl font-bold text-[#FF4902] uppercase">
          Pune - FC Road
        </h2>
      </section>

      {/* Store Info Section */}
      <section className="px-6 md:px-16 lg:px-32 py-10">
        <div className="grid md:grid-cols-2 gap-8 items-center bg-gray-100 p-6 rounded-lg shadow-md">
          {/* Store Image */}
          <img
            src="https://res.cloudinary.com/dypkxqirq/image/upload/v1755688068/a0b247664cdde2260e4f2fc2a01112759c76c302_1_jo2iwn.webp"
            alt="Store Interior"
            className="rounded-lg shadow-lg w-full"
          />

          {/* Store Details */}
          <div className="bg-gray-100 p-6 rounded-lg">
            <p className="mb-4">
              <b>Mammoth Streetwear :- </b> Sagar Arcade, Shop No.586, Gudluck Chowk, F.C. Road, Pune - 411004
            </p>
            <p className="mb-4">
              <b>Timing:</b> 11 AM to 10 PM (Mon - Sun)
            </p>
            <p className="mb-4">
              <b>Email:</b> info@mammothstreetwears.com
            </p>
            <a
              href="https://maps.app.goo.gl/v8H5QoPpSZdmKdCu7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-semibold hover:underline"
            >
              📍 Directions
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      {/* <footer className="bg-black text-white text-center py-4">
        <p>&copy; {new Date().getFullYear()} Mammoth Streetwears. All Rights Reserved.</p>
      </footer> */}
    </div>
  );
}



export default Offilinestore;
